export default "/_next/static/chunks/fonts/SimpleLineIcons-3ec13a24af3fdda1110771d3541915a2.ttf";